import { declareResourceType } from 'rwwa-data-access'
import { TypedRecord, recordify } from 'typed-immutable-record'

export interface IAcceptor {
  key: string
  raceKey: string
  acceptorNumber: number
  bestTimeThisTrackAndDistance?: number
  comment: string
  debut: boolean
  jockeyStats: string
  jumpDirection: string
  preferredTrackPosition: string
  rating: number
  requiredOdds: number
  sectionalTime?: number
  speedMap: number
  speedMapDesc: string
  speedMapLane: number
  startingPosition: number
  isReserve: boolean
  trainerStats: string
  isGiddyupScratched: boolean
}

export interface IAcceptorRecord extends TypedRecord<IAcceptorRecord>, IAcceptor {}

export const GiddyUpAcceptors = declareResourceType({
  typeKey: 'giddyUpAcceptors',
  map: convertJSAcceptorToImmutable,
  ownedBy: (acceptor: IAcceptorRecord) => ['giddyUpRaces', acceptor.raceKey],
  maxToKeep: 0,
})

function convertJSAcceptorToImmutable(acceptor: IAcceptor): IAcceptorRecord {
  return recordify<IAcceptor, IAcceptorRecord>(acceptor)
}
